export default "__VITE_ASSET__CEF7sjHD__"